
/**
 * 트윗 유형
 */
export type TweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof TweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof TweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetResponseReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
